document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('drgShoppingGuideModal');
  if (!modal) return;

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const openButtons = document.querySelectorAll('[data-drg-guide-open]');
  const closeButtons = modal.querySelectorAll('[data-drg-guide-close]');
  const accordionButtons = modal.querySelectorAll('[data-drg-guide-accordion]');
  const sectionCloseButtons = modal.querySelectorAll('[data-drg-guide-section-close]');
  const guideTriggers = document.querySelectorAll('.drg-guide-trigger');

  const resetAccordions = () => {
    modal.querySelectorAll('.drg-guide-accordion').forEach((accordion) => {
      accordion.classList.remove('is-open');

      const icon = accordion.querySelector('.drg-guide-accordion__icon');
      if (icon) icon.textContent = '+';
    });
  };

  const setTriggerOpenState = (isOpen) => {
    guideTriggers.forEach((trigger) => {
      trigger.classList.toggle('is-open', isOpen);
    });
  };

  const openModal = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    setTriggerOpenState(true);
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    setTriggerOpenState(false);
    resetAccordions();
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  accordionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.drg-guide-accordion');
      const panel = modal.querySelector('.drg-guide-modal__panel');

      if (!item || !panel) return;

      const isOpen = item.classList.contains('is-open');

      resetAccordions();

      if (!isOpen) {
        item.classList.add('is-open');

        const icon = item.querySelector('.drg-guide-accordion__icon');
        if (icon) icon.textContent = '−';

        requestAnimationFrame(() => {
          const gap = 65;

          panel.scrollTo({
            top: button.offsetTop - gap,
            behavior: 'smooth'
          });
        });
      }
    });
  });

  sectionCloseButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.drg-guide-accordion');
      if (!item) return;

      item.classList.remove('is-open');

      const icon = item.querySelector('.drg-guide-accordion__icon');
      if (icon) icon.textContent = '+';
    });
  });

  modal.addEventListener('click', (event) => {
    if (event.target.matches('.drg-guide-modal__overlay')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
});